// FIX: NetworkTileTx24h not NetworkTileAvgUtxoAge
import { SingleDataValue } from '.';
import { ThemedFlex } from '../../theme/ThemedFlex';

export const NetworkTileAvgUtxoAge = ({ data, formatNumber, animate }) => {
  const numberValue = data?.s08?.blockchain?.Data?.transaction_count != null
    ? `${formatNumber(data.s08.blockchain.Data.transaction_count, 0)} TXs`
    : '';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="Transactions 24h" value={numberValue} />
    </ThemedFlex>
  );
};